import React from "react";
import { AlertTriangle } from "lucide-react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", this.props.name || "component", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          className="max-w-2xl mx-auto my-10 rounded-xl border border-red-200 bg-red-50 p-6"
          data-testid={`error-boundary-${(this.props.name || "component").toLowerCase()}`}
        >
          <div className="flex items-center gap-2 text-red-700 font-heading font-semibold text-lg">
            <AlertTriangle className="w-5 h-5" /> Something went wrong loading this page.
          </div>
          <p className="text-sm text-red-700/80 mt-2">
            {this.state.error?.message || "An unexpected error occurred while rendering this section."}
          </p>
          <button
            onClick={() => window.location.reload()}
            className="mt-4 px-4 py-2 rounded-lg bg-red-600 text-white text-sm font-medium hover:bg-red-700"
            data-testid="error-boundary-reload"
          >
            Reload page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
